<template>
<div :class="['loading-wrapper-component', class_name]">
    <div v-show="loading" class="foreground">
        <img src="../assets/img/loading-black-32.gif" alt="loading" />
    </div>

    <div class="slot">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    name: "loading-wrapper",

    props: ["loading"],

    data () {
        return {
            loaded: false
        }
    },

    computed: {
        class_name: function () {
            let className = []

            if (this.loading) {
                className.push("loading")
            }

            if (this.loaded) {
                className.push("loaded")
            }

            return className.join(" ")
        }
    }
}
</script>

<style>
.loading-wrapper-component {
    position: relative;
}

.loading-wrapper-component .foreground {
    align-items: center;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    height: calc(100% - 2px);
    justify-content: center;
    left: 1px;
    position: absolute;
    top: 1px;
    width: calc(100% - 2px);
    z-index: 2;
}

.loading-wrapper-component .slot {
    position: relative;
    z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingWrapper.vue